import { Button } from "styled";

import Model from "components/Modal";
import { deleteDocumentById } from "apis/customApiHandler";
import { useQueryClient } from "react-query";
import toast from "react-hot-toast";

const DeleteBodyType = ({ handleClick, id }) => {
  const queryClient = useQueryClient();
  const handleClickDelete = async (id) => {
    const data = await deleteDocumentById("body-type", id);
    if (data) {
      toast.success("Successfully deleted");
      queryClient.invalidateQueries("body-types");
    }
    handleClick();
  };

  return (
    <Model
      handleClick={handleClick}
      title={"Delete Body Type"}
      className="max-w-2xl"
    >
      <div className="p-4">
        <p className="text-red-500 p-5 text-center">
          Are you sure you want to delete this Body type?
        </p>

        <div className="px-5 flex justify-end items-center gap-4 pb-4 flex-wrap sm:w-full">
          <Button bgSecondary onClick={handleClick}>
            No
          </Button>
          <Button type="button" bgPrimary onClick={() => handleClickDelete(id)}>
            Yes
          </Button>
        </div>
      </div>
    </Model>
  );
};

export default DeleteBodyType;
